// This button is used to test Sentry's error tracking
// Should no be used unless you are testing Sentry's error tracking
export default function SentryTestErrorButton() {
  return (
    <button
      type="button"
      onClick={() => {
        console.log(
          `Storefront Checkout Test Error from ${import.meta.env.VITE_SENTRY_ENV} [CODE:011] TIME: ${new Date().toISOString()}`,
        );
        throw new Error(
          `Storefront Checkout Test Error from ${import.meta.env.VITE_SENTRY_ENV} [CODE:011] TIME: ${new Date().toISOString()}`,
        );
      }}
    >
      THIS BUTTON IS TO TEST SENTRY ERROR TRACKING - TEST1
    </button>
  );
}
